import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { ConfigService } from 'app/services';
import { StylesStatus } from 'app/models/users/StylesStatus';
import { TODAService } from 'app/services/toda.service';
import { OpsTowerTODAs } from 'app/models/toda/OpsTowerTODAs';
import { TodaStatusEnum } from 'app/models/enums/toda-status.enum';
import { Utils } from 'app/utils';
import { FieldTypeEnum } from 'app/models';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { EditTableConfig } from 'app/models/configs/edit-table-config';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'ops-tower-todas',
    templateUrl: './ops-tower-todas.component.html',
    styleUrls: ['./ops-tower-todas.component.scss'],
    providers: [MessageService, TODAService]
})
export class OpsTowerTODAsComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public arrayFilterServiceTypes: any = [];
    public arrayFilterStatuses: any = [];
    public arrayFilterLastActiveValues: any = [];
    public tableName = EditTableConfig.TODAs;
    public todas: Array<any> = [];
    public cols: any[] = [
        {
            field: 'Id', header: 'TODA ID', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'todaId',
            placeholder: 'Type here', disableSort: false, showSortIcon: true, active: false
        },
        {
            field: 'Name', header: 'TODA Name', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'todaName',
            placeholder: 'Type here', disableSort: false, showSortIcon: true, active: false
        },
        {
            field: 'VehiclesCount', header: 'No. of Vehicles', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'vehiclesCount',
            placeholder: 'Type here', disableSort: false, showSortIcon: true, active: false
        },
        {
            field: 'DriversCount', header: 'No. of Drivers', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'driversCount',
            placeholder: 'Type here', disableSort: false, showSortIcon: true, active: false
        },
        {
            field: 'RiderServiceType', header: 'Service Type', width: '20%', disableSort: false, showSortIcon: true, fieldType: FieldTypeEnum.Dropdown,
            model: 'serviceType', options: this.arrayFilterServiceTypes, placeholder: 'Please Select', active: false
        },
        {
            field: 'LastActivityAt', header: 'Last Active', width: '20%', disableSort: false, showSortIcon: true, fieldType: FieldTypeEnum.Dropdown,
            model: 'lastActive', options: this.arrayFilterLastActiveValues, placeholder: 'Please Select', active: false
        },
        {
            field: 'TodaActivityStatus', header: 'Status', width: '20%', disableSort: false, showSortIcon: true, fieldType: FieldTypeEnum.Dropdown,
            model: 'activityStatus', options: this.arrayFilterStatuses, placeholder: 'Please Select', active: false
        }
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public fieldTypeEnum = FieldTypeEnum;
    public firstColumnTODAs: OpsTowerTODAs = new OpsTowerTODAs();

    public todaHeaderSearch: any = {
        todaId: null,
        todaName: null,
        vehiclesCount: null,
        driversCount: null,
        serviceType: null,
        lastActive: null,
        activityStatus: null,
    };
    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public loading: boolean = true;

    private searchTimer: number = 0;

    public showDetailTODAsSidebar: boolean = false;
    public selectedTODAs: any;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Operators' }, { label: 'TODAs' }];

    constructor(
        private messageService: MessageService,
        public configService: ConfigService,
        public todaService: TODAService) {
        this.handleHideTransactionInfo = this.handleHideTransactionInfo.bind(this);
    }

    ngOnInit(): void {
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        this.todaHeaderSearch = {};

        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.callGridTitles(skip);
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public filter: {
        searchName: string;
    } = { searchName: ''};

    public handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'TODAID') {
                if (event.target.value){
                    this.todaHeaderSearch.todaId = event.target.value.replace(/\D/g, '');
                }
            }
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    private getTODAs(skip: number): void {
        const dto = {
            SearchName: this.filter.searchName,
            Id: this.todaHeaderSearch.todaId ? this.todaHeaderSearch.todaId : null,
            Name: this.todaHeaderSearch.todaName ? this.todaHeaderSearch.todaName : null,
            VehiclesCount: this.todaHeaderSearch.vehiclesCount ? this.todaHeaderSearch.vehiclesCount : null,
            DriversCount: this.todaHeaderSearch.driversCount ? this.todaHeaderSearch.driversCount : null,
            RiderServiceType: this.todaHeaderSearch.serviceType,
            LastActivityAt: this.todaHeaderSearch.lastActive,
            TodaActivityStatus: this.todaHeaderSearch.activityStatus,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.loading = true;

        this.todaService.getTODAs(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.todas = data.Items;
                this.todas.forEach(item => {
                    this.mergeDropDownDuplicates(item.StatusDisplayText, item.TodaActivityStatus, this.arrayFilterStatuses);
                    this.mergeDropDownDuplicates(item.RiderServiceTypeDisplayText, item.RiderServiceType, this.arrayFilterServiceTypes);
                    this.mergeDropDownDuplicates(item.LastActiveDisplayText, item.LastActivityAt, this.arrayFilterLastActiveValues);
                });
                this.loading = false;
            }).catch(err => {
            this.loading = false;
            throw err;
        });
        this.mergeDropDownDuplicates('All', 0, this.arrayFilterStatuses);
        this.mergeDropDownDuplicates('All', 0, this.arrayFilterServiceTypes);
        this.mergeDropDownDuplicates('All', null, this.arrayFilterLastActiveValues);
    }
    public mergeDropDownDuplicates(name: string, value: any, array: any[]) {
        if (name) {
            const exists = array.some((obj: any) => obj.name === name);
            if (!exists) {
                array.push({
                    name,
                    value
                });
            }
        }
    }

    getStatusStyles(status: any): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        if (status === TodaStatusEnum.Offline) {
            backgroundColor = '#FDEBEA';
            textColor = '#EB4236';
        } else if (status === TodaStatusEnum.Active) {
            backgroundColor = '#E7F7EF';
            textColor = '#1CBA70';
        } else {
            backgroundColor = '';
            textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    onSelectionChange(event: any) {
        this.selectedTODAs = event.data;
    }

    public handleHideTransactionInfo() {
        this.showDetailTODAsSidebar = false;
    }

    public handleShowTransactionInfo(transaction: any) {
        this.selectedTODAs = transaction;
        this.showDetailTODAsSidebar = true;
    }

    callGridTitles(skip: number) {
        this.callTODAs(skip);
    }

    public callTODAs(skip: number) {
        this.firstColumnTODAs = new OpsTowerTODAs();
        this.getTODAs(skip);
    }
    public onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        if (model === 'ServiceType') {
            if (event === 0) {
                this.todaHeaderSearch.serviceType = null;
            }
        }
        else if (model === 'LastActive') {
            if (event === 0) {
                this.todaHeaderSearch.lastActive = null;
            }
        }
        else if (model === 'Status') {
            if (event === 0) {
                this.todaHeaderSearch.activityStatus = null;
            }
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }
    openFilter() { }
}
